import { createNotificationId } from '@/shared/utils/id';
import { notificationActionTypes } from './constants';

import type { NotificationItem, NotificationState } from './types';

interface NotificationActionPayload {
	id?: string | number;
	title?: string;
	subtitle?: string | null;
	timeout?: number;
	error?: boolean;
	clearPreviously?: boolean;
}

interface NotificationAction {
	type: string;
	payload?: NotificationActionPayload;
}

const initialState: NotificationState = {
	notifications: [],
};

export default function notificationReducer(state = initialState, action: NotificationAction): NotificationState {
	const { type, payload } = action;
	const { id, title, subtitle, timeout, error, clearPreviously } = payload || {};

	switch (type) {
		case notificationActionTypes.CREATE_NOTIFICATION_MESSAGE: {
			const newNotification: NotificationItem = {
				id: createNotificationId(),
				title,
				subtitle,
				timeout,
				error,
			};

			return {
				...state,
				notifications: clearPreviously ? [newNotification] : [...state.notifications, newNotification],
			};
		}

		case notificationActionTypes.NOTIFICATION_MESSAGE_CLOSE:
			return {
				...state,
				notifications: state.notifications.filter((item) => item.id !== String(id)),
			};

		case notificationActionTypes.CLEAR_STATE:
			return initialState;

		default:
			return state;
	}
}
